import React from "react";

export const YellowArrow2 = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    width="102"
    height="115"
    viewBox="0 0 102 115"
    style={style}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8854 4.99961L17.9634 77.9506L33.4301 61.3134L62.0834 107.056C62.0834 107.056 66.5852 96.5507 74.7887 88.2234C82.9921 79.8961 95.134 75.0261 95.134 75.0261L56.0672 37.9838L77.0569 25.7371L10.8854 4.99961Z"
      stroke="#FFD100"
      strokeWidth="7"
    />
  </svg>
);
